import * as api from '@/utils/request.js'
import axios from 'axios'

// 专家列表
export function getExportList(params) {
  return api.get(`http://admin.gdsme.org/prod-api/business/expert/listall`, params)
  // return api.get(`http://localhost/prod-api/business/expert/listall`, params)
}

// 新闻列表
export function getNewsList(params) {
  return api.get(`http://admin.gdsme.org/prod-api/business/news/listall`, params)
  // return api.get(`http://localhost/prod-api/business/news/listall`, params)
  // return api.get(`http://` + this.$serverAddress + `/prod-api/business/news/listall`, params)
}

// 新闻详情
export function getNewsListDetails({newsId}) {
  return api.get(`http://admin.gdsme.org/dev-api/business/news/detail/${newsId}`)
  // return api.get(`http://localhost/dev-api/business/news/detail/${newsId}`)
  // return api.get(`http://` + this.$serverAddress + `/prod-api/business/news/detail/${newsId}`)
}

// 获取作品列表;
export function getWorkList(data) {
  return api.get(`http://admin.gdsme.org/prod-api/business/expert/listall`, data)
  // return api.get(`http://localhost/prod-api/business/expert/listall`, data)
}

// 根据年份获取作品列表;
export function getWorkYearList(params) {
  return api.get(`http://admin.gdsme.org/prod-api/business/work/listall`, params)
  // return api.get(`http://localhost/prod-api/business/work/listall`, params)
}

// 查询页脚联系方式信息
export function getFooterInfo() {
  return api.get(`http://admin.gdsme.org/prod-api/system/basic/footer/contactinfo`)
  // return api.get(`http://localhost/prod-api/system/basic/footer/contactinfo`)
}

// 查询页脚粤公安备案信息
export function getRecordNumberPolice() {
  return api.get(`http://admin.gdsme.org/prod-api/system/basic/footer/recordpolice`)
  // return api.get(`http://localhost/prod-api/system/basic/footer/recordpolice`)
}

// 查询页脚ICP备案信息
export function getRecordNumber() {
  return api.get(`http://admin.gdsme.org/prod-api/system/basic/footer/record`)
  // return api.get(`http://localhost/prod-api/system/basic/footer/record`)
}



// WEBPACK FOOTER //
// ./src/api/api.js